import { capitalize } from 'lodash';
import { CSSProperties } from 'react';
import styled from 'styled-components';

import { MenuItem, TextField } from '@material-ui/core';
import { useQuery } from '@tanstack/react-query';

import { adminListMarketsApi } from '../../api/markets/adminListMarketsApi';
import { Market } from '../../graphql/API';

type Props = {
  value?: string;
  handleOnChange: (value?: string) => void;
  containerStyle?: CSSProperties;
};

export const MarketsSelect: React.FC<Props> = ({ value, handleOnChange, containerStyle }) => {
  const { data } = useQuery({
    queryKey: ['admin-list-markets-api'],
    queryFn: async () => {
      const data = await adminListMarketsApi({
        sortBy: 'name',
        sortDirection: 'asc',
        offset: 0,
        limit: 999,
      });
      return data;
    },
  });

  const items = data?.map((m: Market) => {
    return {
      key: m.name || '',
      value: m.id,
    };
  });

  return (
    <SelectContainer>
      <PortfolioBlock style={{ ...containerStyle }}>
        <TextField
          id={'Offer-Category'}
          fullWidth
          placeholder="Offer Category"
          variant="outlined"
          value={value}
          onChange={(e) => {
            handleOnChange(e.target.value);
          }}
          select
        >
          <MenuItem value="all">
            <span>All Markets</span>
          </MenuItem>
          {items &&
            items.map(({ key, value }) => (
              <MenuItem key={key} value={value} style={{ textTransform: 'capitalize' }}>
                <span style={{ textTransform: 'capitalize' }}>{capitalize(key)}</span>
              </MenuItem>
            ))}
        </TextField>
      </PortfolioBlock>
    </SelectContainer>
  );
};

const SelectContainer = styled.div`
  width: 200px;
`;

const PortfolioBlock = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .MuiFormControl-root:focus-visible {
    outline: none !important;
  }
  .MuiSelect-root {
    padding: 7.5px 14px !important;
    font-size: 14px;
  }
  .MuiSelect-select:focus-visible {
    outline: none !important;
  }
  .MuiOutlinedInput-root:focus-visible {
    outline: none !important;
  }
  .MuiTextField-root:focus-visible {
    outline: none !important;
  }
`;
